import React, { useEffect, useState } from 'react';
export default function SponsorSlot({ placement, fallback = null }) {
  const [sponsor, setSponsor] = useState(() => window.KELIMO_SPONSOR);
  useEffect(() => {
    const refresh = () => setSponsor(window.KELIMO_SPONSOR);
    window.addEventListener('kelimo-sponsor-ready', refresh);
    refresh(); // Also covers script completion between render and effect.
    return () => window.removeEventListener('kelimo-sponsor-ready', refresh);
  }, []);
  if (!sponsor || !sponsor.title || !Array.isArray(sponsor.placements) || !sponsor.placements.includes(placement)) return fallback;
  let url; try { url = new URL(sponsor.url); if (url.protocol !== 'https:') return fallback; } catch (_) { return fallback; }
  return <aside aria-label="Sponsor" className="my-4 rounded-xl border border-slate-200 bg-white p-4 text-slate-800"><p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Sponsor</p><a href={url.href} target="_blank" rel="noreferrer" className="mt-2 block font-bold text-indigo-800">{sponsor.title}</a>{sponsor.text && <p className="mt-1 text-xs text-slate-600">{sponsor.text}</p>}</aside>;
}
